import styled from 'styled-components'
import { ButtonProps } from './index'

export const StyledButton = styled.button<
  Pick<ButtonProps, 'width' | 'color' | 'fontSize'>
>`
  box-sizing: border-box;
  color: ${(props) => props.color || 'blue'};
  width: ${(props) => props.width || 'fit-content'};
  font-size: ${(props) => props.fontSize || '1em'};

  &:hover {
    box-shadow: 4px 4px 4px #c0c0c0;
  }

  .iconbtn {
    padding: 0;
  }

  .textbtn {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }
`
